import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';
import { cn } from './lib/cn';
import { forwardRef } from 'react';

type ButtonVariant = 'default' | 'primary' | 'success' | 'secondary' | 'danger';

type ButtonProps = ChakraButtonProps & {
    variant?: ButtonVariant;
    href?: string;
};

export const Button = forwardRef(function Button({ variant = 'default', className, ...rest }: ButtonProps, ref) {
    if (variant === 'primary') {
        return (
            <ChakraButton
                ref={ref}
                colorScheme='blue'
                border='1px solid'
                borderColor='blue.600'
                className={cn('shadow-sm', className)}
                {...rest}
            />
        );
    }

    if (variant === 'success') {
        return (
            <ChakraButton
                ref={ref}
                colorScheme='green'
                border='1px solid'
                borderColor='green.600'
                className={cn('shadow-sm', className)}
                {...rest}
            />
        );
    }

    if (variant === 'secondary') {
        return (
            <ChakraButton
                ref={ref}
                border='1px solid'
                borderColor='gray.300'
                className={cn('shadow-sm', className)}
                {...rest}
            />
        );
    }

    if (variant === 'danger') {
        return (
            <ChakraButton
                ref={ref}
                colorScheme='red'
                border='1px solid'
                borderColor='red.600'
                className={cn('shadow-sm', className)}
                {...rest}
            />
        );
    }

    return (
        <ChakraButton
            ref={ref}
            variant='outline'
            border='1px solid'
            borderColor='gray.300'
            backgroundColor='white'
            className={cn('shadow-sm', className)}
            {...rest}
        />
    );
});
